import { createStore } from 'satcheljs';
import MailLayoutStore from './schema/MailLayoutStore';

const mailLayoutStore: MailLayoutStore = {
    browserWidthBucket: null,
    clientReadingPanePosition: null,
    showReadingPane: false,
    showListPane: true,
    showFolderPane: true,
};

export let getStore = createStore<MailLayoutStore>('maillayout', mailLayoutStore);
